export { useAsyncComponent } from "#use-async-component";
